import { render } from "./EventForm.vue?vue&type=template&id=5a8d58e0&scoped=true"
import script from "./EventForm.vue?vue&type=script&lang=js"
export * from "./EventForm.vue?vue&type=script&lang=js"

import "./EventForm.vue?vue&type=style&index=0&id=5a8d58e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a8d58e0"

export default script